import { Fragment, useEffect, useState } from "react";
// @mui
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import axios from "axios";
import { tooltipClasses } from "@mui/material/Tooltip";
import Iconify from "../../components/iconify";
import AssetsDialog from "./AssetsDialog";
import { TEAMS } from "../../constants/teams";
import { MatchPlayerStats, MatchTeamsStats } from "./OptionPreview";
import { OptionSeasonStats } from "./OptionSeasonStats";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, paddingTop: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const defaultState = {
  title_en: "",
  description_en: "",
  title_fr: "",
  description_fr: "",
  data: {},
};
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const InputTooltip = ({ imgPath }) => (
  <HtmlTooltip
    title={
      <Fragment>
        <img src={imgPath} alt="login" />
      </Fragment>
    }
  >
    <Iconify icon="eva:info-outline" sx={{}} />
  </HtmlTooltip>
);
const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function OptionDialog(props) {
  const [option, setOption] = useState(defaultState);
  const [statsMatch, setStatsMatch] = useState(null);
  const [assetsTarget, setAssetsTarget] = useState(null);
  const [upcomingMatches, setUpcomingMatches] = useState(null);
  const [matchStatsData, setMatchStatsData] = useState(null);

  const [statsLabel, setStatsLabel] = useState(['Stats 1', 'Stats 2', 'Stats 3', 'Stats 4', 'Stats 5' ]);
  const [stats, setStats] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.option !== null) {
      setOption(props.option);
      if (props.option?.data?.match_id) {
        setStatsMatch(props.option.data.match_id);
      }
    } else {
      setStatsMatch(null);
    }
  }, [props]);

  useEffect(() => {
    if (statsMatch !== null) {
      axios
        .get(
          `${process.env.REACT_APP_FEED_BASE_URL}/hockey/matches/${statsMatch}?token=${process.env.REACT_APP_FEED_TOKEN}`
        )
        .then(function (response) {
          if (response.data) {
            setMatchStatsData(response.data.MatchStats);

            const teamData = TEAMS.find(
              (team) => team.teamId === option.data.team_id
            );
            if (response.data.away_team.TeamFeedId == teamData?.abbr) {
              customHandleDataChange("opp_name", response.data.home_team.TeamFeedId);
              customHandleDataChange("opp_score", response.data.HomeTeamScore);
              customHandleDataChange("team_name", response.data.away_team.TeamFeedId);
              customHandleDataChange("team_score", response.data.AwayTeamScore);
            } else {
              customHandleDataChange("opp_name", response.data.away_team.TeamFeedId);
              customHandleDataChange("opp_score", response.data.AwayTeamScore);
              customHandleDataChange("team_name", response.data.home_team.TeamFeedId);
              customHandleDataChange("team_score", response.data.HomeTeamScore);
            }
          }
        });
    }
  }, [statsMatch]);

  const findPlayer = (data) => {
    if (!!option?.data?.team_id) {
      const teamData = TEAMS.find(
        (team) => team.teamId === option.data.team_id
      );
      const team = data.find((item) => item.TeamFeedId === teamData?.abbr);
      if (!!option?.data?.player_id) {
        const player = team.Players.find(
          (item) => item.PlayerFeedId === option?.data?.player_id
        );
        return player;
      }
      return null;
    }
    return null;
  };

  useEffect(() => {
    if (option.data.team_id && !option.data.player_id) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/team-stats?teamId=${option.data.team_id}`
        )
        .then(function (response) {
          setIsLoading(false);
          setStats(response?.data);
          setStatsData(response?.data, 'team')
        });
    } else if (option.data.player_id && option.data.team_id) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/player-stats?teamId=${option.data.team_id}&playerId=${option.data.player_id}`
        )
        .then(function (response) {
          setIsLoading(false);
          setStats(response?.data?.player);
          if (response?.data?.player) {
            setStatsData(response?.data, 'player')
            //customHandleDataChange('possition', response?.data?.player?.pos)
          }
        });
      axios
        .get(
          `${process.env.REACT_APP_FEED_BASE_URL}/hockey/tournament/1/teams?season=2023&token=${process.env.REACT_APP_FEED_TOKEN}`
        )
        .then(function (response) {
          if (response.data) {
            if (!!option.data.player_id) {
              const player = findPlayer(response.data?.squad?.Teams);
              customHandleDataChange(
                "jersey_number",
                !!player ? player?.JerseyNumber : 0
              );
              customHandleDataChange(
                "possition",
                !!player ? player?.Position : null
              );
            }
          }
        });
    }
  }, [option.data.team_id, option.data.player_id]);

  useEffect(() => {
    if(process.env.REACT_APP_NAME == "pepsi") {
      if(!option?.data?.team_id && !option?.data?.player_id) {
        setStatsLabel(["Wins", "Saves Per Game", "Shutouts", "", ""])
      } else {
        setStatsLabel(["Games Played", "Wins", "Shutouts", "Goals Against Average", "Save %"])
      }
    } else if(process.env.REACT_APP_NAME == "oilers") {
      setStatsLabel(["Goals", "Assists", "Shot", "Hit", "Blocked Shot"])
    } else {
      setStatsLabel(["Goals", "Assists", "Points", "Shots", "Plus/Minus"])
    }
  }, []);

  const setStatsData = (data, type, reset = false) => {
    if(process.env.REACT_APP_NAME == "pepsi") {
      if(type === 'team') {
        const item = Number(data?.stats?.sa || 0) / Number(data?.stats?.gp || 0);
        customHandleDataChange("stats_1", (reset) ? data?.stats?.w ?? 0 : option?.data?.stats_1 ?? data?.stats?.w ?? 0);
        customHandleDataChange("stats_2", (reset) ? Number(data?.stats?.sa).toFixed(1) ?? 0 : option?.data?.stats_2 ?? Number(data?.stats?.sa).toFixed(1) ?? 0);
        customHandleDataChange("stats_3", (reset) ? 0 : option?.data?.stats_3 ?? 0);
      } else {
        customHandleDataChange("stats_4", (reset) ? data?.stats?.gp ?? 0 : option?.data?.stats_4 ?? data?.stats?.gp ?? 0);
        customHandleDataChange("stats_5", (reset) ? data?.stats?.w ?? 0 : option?.data?.stats_5 ?? data?.stats?.w ?? 0);
        // customHandleDataChange("stats_6", (reset) ? 0 : option?.data?.stats_6 ?? 0);
        // customHandleDataChange("stats_7", (reset) ? data?.stats?.evGGARatio ?? 0 : option?.data?.stats_7 ?? data?.stats?.evGGARatio ?? 0);
        // customHandleDataChange("stats_8", (reset) ? data?.stats?.s ?? 0 : option?.data?.stats_8 ?? data?.stats?.s ?? 0);
      }
    } else if(process.env.REACT_APP_NAME == "oilers") {
      if(type === 'player') {
        customHandleDataChange("stats_1", (reset) ? data?.player?.g ?? 0 : option?.data?.stats_1 ?? data?.player?.g ?? 0);
        customHandleDataChange("stats_2", (reset) ? data?.player?.a ?? 0 : option?.data?.stats_2 ?? data?.player?.a ?? 0);
        customHandleDataChange("stats_3", (reset) ? data?.player?.s ?? 0 : option?.data?.stats_3 ?? data?.player?.s ?? 0);
        customHandleDataChange("stats_4", (reset) ? data?.player?.s ?? 0 : option?.data?.stats_4 ?? data?.player?.s ?? 0);
        customHandleDataChange("stats_5", (reset) ? data?.player?.s ?? 0 : option?.data?.stats_5 ?? data?.player?.s ?? 0);

        customHandleDataChange("game_played", data?.player?.gp ?? 0);
      }
    } else {
      if(type === 'team') {
        customHandleDataChange("stats_1", (reset) ? data?.stats?.g ?? 0 : option?.data?.stats_1 ?? data?.stats?.g ?? 0);
        customHandleDataChange("stats_2", (reset) ? 0 : option?.data?.stats_2 ?? 0);
        customHandleDataChange("stats_3", (reset) ? data?.stats?.pts ?? 0 : option?.data?.stats_3 ?? data?.stats?.pts ?? 0);
        customHandleDataChange("stats_4", (reset) ? data?.stats?.s ?? 0 : option?.data?.stats_4 ?? data?.stats?.s ?? 0);
        customHandleDataChange("stats_5", (reset) ? 0 : option?.data?.stats_5 ?? 0);
      } else {
        customHandleDataChange("stats_1", (reset) ? data?.player?.g ?? 0 : option?.data?.stats_1 ?? data?.player?.g ?? 0);
        customHandleDataChange("stats_2", (reset) ? data?.player?.a ?? 0 : option?.data?.stats_2 ?? data?.player?.a ?? 0);
        customHandleDataChange("stats_3", (reset) ? data?.player?.pts ?? 0 : option?.data?.stats_3 ?? data?.player?.pts ?? 0);
        customHandleDataChange("stats_4", (reset) ? data?.player?.s ?? 0 : option?.data?.stats_4 ?? data?.player?.s ?? 0);
        customHandleDataChange("stats_5", (reset) ? data?.player["+/-"] ?? 0 : option?.data?.stats_5 ?? data?.player["+/-"] ?? 0);
      }
    }
  }

  const resetStatsData = () => {
    if (option.data.team_id && !option.data.player_id) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/team-stats?teamId=${option.data.team_id}`
        )
        .then(function (response) {
          setIsLoading(false);
          setStats(response?.data);
          setStatsData(response?.data, 'team', true)
        });
    } else if (option.data.player_id && option.data.team_id) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/player-stats?teamId=${option.data.team_id}&playerId=${option.data.player_id}`
        )
        .then(function (response) {
          setIsLoading(false);
          if (response?.data?.player) {
            setStatsData(response?.data, 'player', true)
          }
        });
    }
  }

  useEffect(() => {
    if (upcomingMatches === null && process.env.REACT_APP_FEED_NAME === "nhl") {
      axios
        .get(
          `${process.env.REACT_APP_FEED_BASE_URL}/hockey/tournament/1/matches?start_date=2024-06-01T01:00:00.000Z&end_date=2024-12-30T02:00:00.000Z&season=2023&token=${process.env.REACT_APP_FEED_TOKEN}`
        )
        .then(function (response) {
          setUpcomingMatches(response.data);
        });
    }
  }, []);
  const handleChange = (e) => {
    const { id, value } = e.target;

    setOption((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleDataChange = (e) => {
    const { id, value } = e.target;
    console.log('handleDataChange', id, value)
    let data = option.data;
    data[id] = value;
    console.log('data', data)
    setOption((prevState) => ({
      ...prevState,
      data: { ...data },
    }));
  };

  const customHandleDataChange = (key, value) => {
    let data = option.data;
    data[key] = value;
    
    setOption((prevState) => ({
      ...prevState,
      data: { ...data },
    }));
  };

  const handleChangeIshot = (e) => {
    let data = option.data;
    data.is_hot = e.target.checked;
    setOption((prevState) => ({
      ...prevState,
      data: { ...data },
    }));
  };
  const [value, setValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const deleteImage = (key) => {
    setOption((prevState) => ({
      ...prevState,
      [key]: null,
    }));
  };
  const onSuccess = () => {
    setOption(defaultState);
    props.onSuccessHandler(option);
  };
  const onCancel = () => {
    setOption(defaultState);
    props.onClose();
  };
  const onChoseAsset = (
    assetUrl,
    title_en = null,
    title_fr = null,
    description_en = null,
    description_fr = null,
    jersey_number = null,
    option_secondary_image = null,
    teamId = null,
    playerId = null
  ) => {
    setOption((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    if (
      assetsTarget === "option_image" &&
      title_en !== null &&
      title_fr !== null
    ) {
      setOption((prevState) => ({
        ...prevState,
        title_en,
        title_fr,
      }));
    }
    if (
      assetsTarget === "option_secondary_image" &&
      title_en !== null &&
      title_fr !== null
    ) {
      setOption((prevState) => ({
        ...prevState,
        additional_title_en: title_en,
        additional_title_fr: title_fr,
      }));
    }
    if (
      assetsTarget === "option_image" &&
      description_en !== null &&
      description_fr !== null
    ) {
      setOption((prevState) => ({
        ...prevState,
        description_en,
        description_fr,
      }));
    }
    if (assetsTarget === "option_image" && jersey_number !== null) {
      setOption((prevState) => ({
        ...prevState,
        data: { ...prevState.data, jersey_number },
      }));
    }
    if (assetsTarget === "option_image" && option_secondary_image !== null) {
      if(process.env.REACT_APP_NAME !== "pepsi") {
        setOption((prevState) => ({
          ...prevState,
          option_secondary_image,
        }));
      } else {
        setOption((prevState) => ({
          ...prevState,
          option_third_image: option_secondary_image,
        }));
      }
    }
    if (teamId !== null) {
      setOption((prevState) => ({
        ...prevState,
        data: { ...prevState.data, team_id: teamId },
      }));
    }
    setOption((prevState) => ({
      ...prevState,
      data: { ...prevState.data, player_id: playerId },
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const handleOptionStartChange = (newValue) => {
    setOption((prevState) => ({
      ...prevState,
      start_utc: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const changeStatsMatch = (event) => {
    const match = upcomingMatches.matches.find(
      (item) => item?.MatchFeedId === event.target.value
    );
    const teamData = TEAMS.find((team) => team.teamId === option.data.team_id);
    let opp;
    let team;
    if (true) {
      if (match.AwayTeamFeedId === teamData.team_id) {
        team = TEAMS.find(
          (constantTeam) => constantTeam?.abbr === match.HomeTeamFeedId
        );
      }
      if (match.HomeTeamFeedId === teamData.team_id) {
        team = TEAMS.find(
          (constantTeam) => constantTeam.teamId === match.AwayTeamFeedId
        );
      }
      opp = team?.abbr;
    }
    setStatsMatch(event.target.value);

    setOption((prevState) => ({
      ...prevState,
      data: { ...prevState.data, match_id: event.target.value, opp_name: opp },
    }));
  };
  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Add Option</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {process.env.REACT_APP_NAME !== "pepsi" && (
                <>
                  <Grid item xs={6}>
                    <Grid container>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        Main Image
                        <InputTooltip imgPath="/assets/tooltips/main-image.png" />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        {option.option_image ? (
                          <>
                            <Avatar
                              sx={{ margin: "0 auto", width: 100, height: 100 }}
                              alt="Remy Sharp"
                              src={option.option_image}
                            />
                            <Iconify
                              icon="eva:edit-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() => setAssetsTarget("option_image")}
                            />
                            <Iconify
                              icon="eva:close-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() => deleteImage("option_image")}
                            />
                          </>
                        ) : (
                          <Iconify
                            icon="eva:plus-circle-outline"
                            sx={{
                              width: 30,
                              height: 30,
                              cursor: "pointer",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                            onClick={() => setAssetsTarget("option_image")}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <Grid container>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        Secondary Image
                        <InputTooltip imgPath="/assets/tooltips/secondary-image.png" />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        {option.option_secondary_image ? (
                          <>
                            <Avatar
                              sx={{ margin: "0 auto", width: 100, height: 100 }}
                              alt="Remy Sharp"
                              src={option.option_secondary_image}
                            />
                            <Iconify
                              icon="eva:edit-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() =>
                                setAssetsTarget("option_secondary_image")
                              }
                            />
                            <Iconify
                              icon="eva:close-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() =>
                                deleteImage("option_secondary_image")
                              }
                            />
                          </>
                        ) : (
                          <Iconify
                            icon="eva:plus-circle-outline"
                            sx={{
                              width: 30,
                              height: 30,
                              cursor: "pointer",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                            onClick={() =>
                              setAssetsTarget("option_secondary_image")
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                    <TextField
                      id="odds_marketing_id"
                      label="Odds Marketing Id"
                      fullWidth
                      value={option.odds_marketing_id}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}
              {process.env.REACT_APP_NAME === "pepsi" && (
                <>
                  <Grid item xs={4}>
                    <Grid container>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        Main Image
                        <InputTooltip imgPath="/assets/tooltips/main-image.png" />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        {option.option_image ? (
                          <>
                            <Avatar
                              sx={{ margin: "0 auto", width: 100, height: 100 }}
                              alt="Remy Sharp"
                              src={option.option_image}
                            />
                            <Iconify
                              icon="eva:edit-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() => setAssetsTarget("option_image")}
                            />
                            <Iconify
                              icon="eva:close-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() => deleteImage("option_image")}
                            />
                          </>
                        ) : (
                          <Iconify
                            icon="eva:plus-circle-outline"
                            sx={{
                              width: 30,
                              height: 30,
                              cursor: "pointer",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                            onClick={() => setAssetsTarget("option_image")}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={4}>
                    <Grid container>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        Secondary Image
                        <InputTooltip imgPath="/assets/tooltips/secondary-image.png" />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        {option.option_secondary_image ? (
                          <>
                            <Avatar
                              sx={{ margin: "0 auto", width: 100, height: 100 }}
                              alt="Remy Sharp"
                              src={option.option_secondary_image}
                            />
                            <Iconify
                              icon="eva:edit-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() =>
                                setAssetsTarget("option_secondary_image")
                              }
                            />
                            <Iconify
                              icon="eva:close-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() =>
                                deleteImage("option_secondary_image")
                              }
                            />
                          </>
                        ) : (
                          <Iconify
                            icon="eva:plus-circle-outline"
                            sx={{
                              width: 30,
                              height: 30,
                              cursor: "pointer",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                            onClick={() =>
                              setAssetsTarget("option_secondary_image")
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                    <TextField
                      id="odds_marketing_id"
                      label="Odds Marketing Id"
                      fullWidth
                      value={option.odds_marketing_id}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Grid container>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        Third Image
                        <InputTooltip imgPath="/assets/tooltips/third-image.png" />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        {option.option_third_image ? (
                          <>
                            <Avatar
                              sx={{ margin: "0 auto", width: 100, height: 100 }}
                              alt="Remy Sharp"
                              src={option.option_third_image}
                            />
                            <Iconify
                              icon="eva:edit-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() =>
                                setAssetsTarget("option_third_image")
                              }
                            />
                            <Iconify
                              icon="eva:close-outline"
                              sx={{ width: 30, height: 30, cursor: "pointer" }}
                              onClick={() => deleteImage("option_third_image")}
                            />
                          </>
                        ) : (
                          <Iconify
                            icon="eva:plus-circle-outline"
                            sx={{
                              width: 30,
                              height: 30,
                              cursor: "pointer",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                            onClick={() =>
                              setAssetsTarget("option_third_image")
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                    <TextField
                      id="odds_marketing_id"
                      label="Odds Marketing Id"
                      fullWidth
                      value={option.odds_marketing_id}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={value}
                      onChange={handleChangeTabs}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="EN"
                        {...a11yProps(0)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="FR"
                        {...a11yProps(1)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="SL"
                        {...a11yProps(2)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="ES"
                        {...a11yProps(3)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="LV"
                        {...a11yProps(4)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="RU"
                        {...a11yProps(5)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="ESP"
                        {...a11yProps(6)}
                      />
                      <Tab
                        sx={{ minWidth: 20, width: 50 }}
                        label="DE"
                        {...a11yProps(7)}
                      />
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0}>
                    <TextField
                      id="title_en"
                      label="Title"
                      fullWidth
                      value={option.title_en}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_en"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_en}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_en"
                      label="Description"
                      fullWidth
                      value={option.description_en}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_en"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.data?.hot_cold_label_en}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_en"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_en}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>

                  <TabPanel value={value} index={1}>
                    <TextField
                      id="title_fr"
                      label="Title"
                      fullWidth
                      value={option.title_fr}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_fr"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_fr}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_fr"
                      label="Description"
                      fullWidth
                      value={option.description_fr}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_fr"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_fr}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_fr"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_fr}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <TextField
                      id="title_sl"
                      label="Title"
                      fullWidth
                      value={option.title_sl}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_sl"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_sl}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_sl"
                      label="Description"
                      fullWidth
                      value={option.description_sl}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_sl"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_sl}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_sl"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_sl}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={3}>
                    <TextField
                      id="title_es"
                      label="Title"
                      fullWidth
                      value={option.title_es}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_es"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_es}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_es"
                      label="Description"
                      fullWidth
                      value={option.description_es}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_es"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_es}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_es"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_es}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={4}>
                    <TextField
                      id="title_lt"
                      label="Title"
                      fullWidth
                      value={option.title_lt}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_lt"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_lt}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_lt"
                      label="Description"
                      fullWidth
                      value={option.description_lt}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_lt"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_lt}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_lt"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_lt}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={5}>
                    <TextField
                      id="title_rus"
                      label="Title"
                      fullWidth
                      value={option.title_rus}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_rus"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_rus}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_rus"
                      label="Description"
                      fullWidth
                      value={option.description_rus}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_rus"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_rus}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_rus"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_rus}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={6}>
                    <TextField
                      id="title_esp"
                      label="Title"
                      fullWidth
                      value={option.title_esp}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_esp"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_esp}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_esp"
                      label="Description"
                      fullWidth
                      value={option.description_esp}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_esp"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_esp}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_esp"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_esp}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={7}>
                    <TextField
                      id="title_de"
                      label="Title"
                      fullWidth
                      value={option.title_de}
                      variant="standard"
                      onChange={handleChange}
                    />
                    {process.env.REACT_APP_NAME === "pepsi" && (
                      <TextField
                        id="additional_title_de"
                        label="Additional Title"
                        fullWidth
                        value={option.additional_title_de}
                        variant="standard"
                        onChange={handleChange}
                      />
                    )}
                    <TextField
                      id="description_de"
                      label="Description"
                      fullWidth
                      value={option.description_de}
                      variant="standard"
                      onChange={handleChange}
                    />

                    <TextField
                      id="hot_cold_label_de"
                      label="Hot/Cold Text"
                      fullWidth
                      value={option.hot_cold_label_de}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                    <InputTooltip imgPath="/assets/tooltips/hot-cold-label.png" />
                    <TextField
                      id="odds_description_de"
                      label="Odds Description"
                      fullWidth
                      value={option.odds_description_de}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </TabPanel>
                  {upcomingMatches && (
                    <Grid container spacing={3}>
                      <Grid item xs={6} sm={6} md={6}>
                        <FormControl sx={{ m: 1, width: 200 }} size="small">
                          <InputLabel id="demo-simple-select-label">
                            Match
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={statsMatch}
                            label="Match"
                            onChange={changeStatsMatch}
                          >
                            {upcomingMatches.matches
                              .filter((item) => {
                                if (!option.data.team_id) {
                                  return null;
                                }
                                const team = TEAMS.find(
                                  (team) => team.teamId === option.data.team_id
                                );
                                if (
                                  item.AwayTeamFeedId === team?.abbr ||
                                  item.HomeTeamFeedId === team?.abbr
                                ) {
                                  const today = new Date("2023-11-30");
                                  const yesterday = new Date(today);

                                  yesterday.setDate(yesterday.getDate() - 1);
                                  return (
                                    new Date(item.StartDateUtc).getTime() >
                                    yesterday.getTime()
                                  );
                                }
                                return false;
                              })
                              .map((match) => (
                                <MenuItem
                                  value={match?.MatchFeedId}
                                  key={match?.MatchFeedId}
                                >
                                  {match.HomeTeamName} vs {match.AwayTeamName} |{" "}
                                  {match.StartDateUtc}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DateTimePicker
                            label="Start UTC"
                            value={moment(option.start_utc, dateFormat)}
                            onChange={handleOptionStartChange}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid
                        pl={4}
                        sx={{
                          justifyContent: "space-between",
                          display: "flex",
                          width: 1,
                        }}
                      >
                        {isLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              width: 1,
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        ) : (
                          <>
                            {process.env.REACT_APP_NAME === "pre-play" &&
                              option.data.team_id &&
                              stats && (
                                <OptionSeasonStats
                                  playerId={option?.data?.player_id || null}
                                  teamId={option?.data?.team_id}
                                  stats={stats}
                                />
                              )}
                            {process.env.REACT_APP_NAME === "pepsi" && (
                              <Grid item xs={12}>
                                {option?.data?.player_id &&
                                option?.data?.player_id !== null ? (
                                  <MatchPlayerStats
                                    matchId={statsMatch}
                                    playerId={option?.data?.player_id}
                                    matchStats={matchStatsData}
                                  />
                                ) : (
                                  <MatchTeamsStats
                                    matchId={statsMatch}
                                    matchStats={matchStatsData}
                                  />
                                )}
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      id="stats_1"
                      label={statsLabel[0]}
                      fullWidth
                      value={option?.data?.stats_1}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="stats_2"
                      label={statsLabel[1]}
                      fullWidth
                      value={option?.data?.stats_2}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="stats_3"
                      label={statsLabel[2]}
                      fullWidth
                      value={option?.data?.stats_3}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="stats_4"
                      label={statsLabel[3]}
                      fullWidth
                      value={option?.data?.stats_4}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="stats_5"
                      label={statsLabel[4]}
                      fullWidth
                      value={option?.data?.stats_5}
                      variant="standard"
                      onChange={handleDataChange}
                    />
                  </Grid>
                  {process.env.REACT_APP_NAME === 'pepsi' && (
                    <>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_6"
                        label={"stats_6"}
                        fullWidth
                        value={option?.data?.stats_6}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_7"
                        label={"stats_7"}
                        fullWidth
                        value={option?.data?.stats_7}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_8"
                        label={"stats_8"}
                        fullWidth
                        value={option?.data?.stats_8}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_9"
                        label={"stats_9"}
                        fullWidth
                        value={option?.data?.stats_9}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_10"
                        label={"stats_10"}
                        fullWidth
                        value={option?.data?.stats_10}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_11"
                        label={"stats_11"}
                        fullWidth
                        value={option?.data?.stats_11}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_12"
                        label={"stats_12"}
                        fullWidth
                        value={option?.data?.stats_12}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_13"
                        label={"stats_13"}
                        fullWidth
                        value={option?.data?.stats_13}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_14"
                        label={"stats_14"}
                        fullWidth
                        value={option?.data?.stats_14}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="stats_15"
                        label={"stats_15"}
                        fullWidth
                        value={option?.data?.stats_15}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                    </Grid>
                    </>
                  )}
                  <Grid item xs={4}>
                    <Button onClick={resetStatsData}>Reset Stats</Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ width: "100%" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        id="target_score"
                        label="Target Score"
                        fullWidth
                        value={option.data?.target_score}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                      <InputTooltip imgPath="/assets/tooltips/target-score.png" />
                    </Grid>

                    <Grid item xs={4}>
                      <TextField
                        id="jersey_number"
                        label="Jersey Number"
                        fullWidth
                        value={option.data?.jersey_number}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                      <InputTooltip imgPath="/assets/tooltips/jersey-number.png" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="opp_name"
                        label="Opp. Name"
                        fullWidth
                        value={option.data?.opp_name}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                      <InputTooltip imgPath="/assets/tooltips/opponent-name.png" />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id="possition"
                        label="Possition"
                        fullWidth
                        value={option.data?.possition}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                      <InputTooltip imgPath="/assets/tooltips/possition.png" />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={option.data.is_hot ?? false}
                            onChange={handleChangeIshot}
                            id="is_hot"
                          />
                        }
                        label="Is Hot"
                      />
                      <InputTooltip imgPath="/assets/tooltips/is-hot.png" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="sponsor_odds"
                        label="Sponsor Odds"
                        fullWidth
                        value={option.data?.sponsor_odds}
                        variant="standard"
                        onChange={handleDataChange}
                      />
                      <InputTooltip imgPath="/assets/tooltips/sponsor-odds.png" />
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "center" }}>
                      <Box>Sponsor Logo</Box>
                      {option.option_sponsor_image ? (
                        <>
                          <img
                            style={{
                              margin: "0 auto",
                              width: 100,
                              background: "grey",
                            }}
                            alt="Remy Sharp"
                            src={option.option_sponsor_image}
                          />
                          <Iconify
                            icon="eva:edit-outline"
                            sx={{ width: 20, height: 20, cursor: "pointer" }}
                            onClick={() =>
                              setAssetsTarget("option_sponsor_image")
                            }
                          />
                        </>
                      ) : (
                        <Iconify
                          icon="eva:plus-circle-outline"
                          sx={{
                            width: 20,
                            height: 20,
                            cursor: "pointer",
                            marginTop: 2,
                            marginBottom: 2,
                          }}
                          onClick={() =>
                            setAssetsTarget("option_sponsor_image")
                          }
                        />
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id="player_id"
                        label="Player Id"
                        fullWidth
                        value={option.data.player_id}
                        variant="standard"
                        onChange={(e) => customHandleDataChange(e.target.id, e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button onClick={() => onSuccess()} autoFocus>
              {props.option === null ? "Add" : "Edit"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
